import "./WaterHeaterProblems.module.css";
import Header from "@/reusable_sections/Header";
import HeaterIssues from "./sections/HeaterIssues";
import Symptoms from "./sections/Symptoms";
import ServiceContact from "./sections/ServiceContact";
import Footer from "@/reusable_sections/Footer";
export default function WaterHeaterProblemsPage() {
  return <div>
      <Header />
      <HeaterIssues />
      <Symptoms />
      <ServiceContact />
      <Footer />
    </div>;
}